import { ActionButton } from "@components/_Revamp/ActionButton/ActionButton";
import BottomSheet from "@components/_Revamp/BottomSheet";
import Button from "@components/_Revamp/Button";
import Icon from "@components/_Revamp/Icon";
import Modal from "@components/_Revamp/Modal";
import {
  RadioButton,
  RadioButtonGroup,
} from "@components/_Revamp/RadioButton/RadioButton";
import Stepper from "@components/_Revamp/Stepper";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription/TitleAndDescription";
import Typography from "@components/_Revamp/Typography";
import { styled } from "@linaria/react";
import { BasicDetailsForm } from "@models/MLTC_R3/BasicDetails.model";
import { CoverageForm } from "@models/MLTC_R3/Coverage.model";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import DOMPurify from "dompurify";
import {
  updateBasicDetails,
  updateCoverage,
} from "@redux/slices/MLTC_R3/step1Slice";
import { completeStep, updateAgentDetailResponseRaw, updateAgentInformation, updatePromoCode, updateQRClntNum, updateCareShieldPlanName, updateShowArcPage, updateValidPromoCodeValidity, updateQRMonthlyBenefit, updateQRTerm, setHasShownQREligiblePopup, updateQRClientDetails, resetQRData, updateEBCampaignCompanyName } from "@redux/slices/MLTC_R3/step5Slice";
import { GAAviva, MLTC_R3_JOURNEY_NAME } from "@utils/gaAvivaR3";
import { Helpers } from "@utils/helpers";
import useForm from "@utils/useForm";
import { find, get, isEmpty } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { scrollToRef } from "../../../utils/scrollScript";
import { calculateSpacer } from "../../../utils/spaceCalculation";
import DayOfBirth from "./components/DayOfBirth";
import { EErrorCode, validate } from "./service";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import Text from "@components/Text";
import { CONTENT } from "@static/content";
import Lottie from "react-lottie-player";
import animate_logo_json from "@assets/images/singlife-logo-purple.json";
import { resetToIntialStateStep4 } from "@redux/slices/MLTC_R3/step4Slice";
import { setCampaignDetail, setInvalidArcCodeFromUrl, setLoadingState } from "@redux/slices/loadingSlice";
import { postGetPersonalDetails, postRetrieveInformation } from "@api/index";
import { AgentPersonalDetailRequest } from "@models/AgentPersonalDetailRequest.model";
import { updateUrlParam } from "@redux/slices/MLTC_R3/urlAnalyticSlice";
import QRSuccessModal from "./components/QRSuccessModal";
import successTickIcon from "@assets/icon/round-tick-success.svg";
import InfoAnimationIcon from "@assets/icon/info-animation-grey.svg"
import EBCampaignBanner from "@assets/images/eb-campaign-banner-image.svg"
import warningIcon from "@assets/icon/info-yellow.svg";
import { updateCoverageTerm, updateGIONRICDetails, updatePlanDetails, updatePlanSelection } from "@redux/slices/MLTC_R3/step2Slice";
import { css } from "@linaria/core";
import EBCampaignModal from "./components/EBCampaignModal";
import EBExpiredLinkModal from "./components/EBExpiredLinkModal";
import { EB_LTC_EXPIRED_LINK_ROUTE } from "@static/staticConstents";

const TitleContainer = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  @media screen and (min-width: 768px) {
    margin: 0 0 64px 0;
    row-gap: 13px;
  }
`;

const ErrorMessage = styled.div`
  display: flex;
  column-gap: 15px;
  align-items: flex-start;
  justify-content: center;
  padding: 0 0 24px 0;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`;

const BasicInfoContainer = styled.div`
  position: relative;
  padding: 0 100px;
  margin: 0 auto;
  /* max-width: 1230px; */
  display: block;
  flex-wrap: wrap;
  padding: 0 24px;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    padding: 0 100px;
  }
`;

const FormContainer = styled.div<FormContainerProps>`
  opacity: 0;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  /* flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center; */
  transition: all 0.2s ease;
  /* max-width: 327px; */
  margin: 200px auto 100px auto;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin: ${(props) => (props.margin ? props.margin : "150px auto 0 auto")};
  }
`;

const DOBInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: unset;
  /* width: 100%; */
  margin: 54px auto 0;
  /* padding: 36px 64px;
  border-radius: 24px;
  background: #FAFAFA; */
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
  }
`;

const GenderInputGroup = styled.div`
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: unset;
  margin: 0 auto 0 auto;
  /* padding: 36px 64px;
  border-radius: 24px;
  background: #FAFAFA; */
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
  }
`;

export interface FormContainerProps {
  margin?: string;
}
const page = "MLTCR3 Basic Details";

export const BasicDetailsMLTCR3 = () => { 
  const qrClientDetails = useAvivaSelector(
    (state) => state.mltcR3Step5.qrClientDetails,
  );
  const validQRClient = qrClientDetails?.status === "SUCCESS";
  const stepsList: Step[] = [
    {
      label: "Basic Info",
      isCurrentStep: validQRClient ? false : true,
      path: "/mltc/lets-get-started",
      disabled: validQRClient
    },
    {
      label: "Quote",
      isCurrentStep: false,
      path: "/mltc/choose-plan",
    },
    {
      label: "Health Declaration",
      isCurrentStep: false,
      path: "/mltc/health",
    },
    {
      label: "Start Application",
      isCurrentStep: false,
      path: "/mltc/my-info",
    },
    {
      label: "Review & Payment",
      isCurrentStep: false,
      path: "/mltc/review",
    },
  ];
  const history = useHistory();
  const location = useLocation();

  const dispatch = useAvivaDispatch();
  const basicDetails = useAvivaSelector(
    (state) => state.mltcR3Step1.basicDetails
  );
  const coverage = useAvivaSelector((state) => state.mltcR3Step1.coverage);
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param
  );
  const completedProcess = useAvivaSelector(
    (state) => state.mltcR3Step5.isCompleted
  );

  const encryptedClntNum = useAvivaSelector(
    (state) => state.mltcR3Step5.clntNum,
  );

  const hasShowQREligiblePopup = useAvivaSelector(
    (state) => state.mltcR3Step5.hasShowQREligiblePopup,
  );

  const ebCampaignLookupComplete = useAvivaSelector(
    (state) => state.mltcR3Step5.ebCampaignLookupComplete,
  );

  const ccCampaignLookupComplete = useAvivaSelector(
    (state) => state.mltcR3Step5.ccCampaignLookupComplete,
  );

  const encryptedCareShieldPlanName = useAvivaSelector(
    (state) => state.mltcR3Step5.careShieldPlanName,
  );

  const rawAgentDetailResponse = useAvivaSelector(
    (state) => state.mltcR3Step5.agentDetailResponseRaw,
  );
  const resetQRValues = useAvivaSelector((state) => state.mltcR3Step5.resetQRData);  
  const clientQRData = validQRClient ? qrClientDetails?.clientMasterData : null;
  const gioNricDetails = useAvivaSelector(state => state.mltcR3Step2.gioNricDetails);
  const QRTermValue = useAvivaSelector((state) => state.mltcR3Step5.QRTerm);
  const QRMonthlyBenefitValue = useAvivaSelector((state) => state.mltcR3Step5.QRMonthlyBenefit);
  const isTokenSet = useAvivaSelector((state) => state.loading.isTokenRecieved);
  const EBCampaignCompanyName = useAvivaSelector((state) => state.mltcR3Step5.EBCampaignCompanyName);
  const productDescription = CONTENT["MLTC"].features;
  const disclaimer = CONTENT["MLTC"].disclaimer;

  const EBCompanyName = campaignDetail?.companyName;
  const [showEBModal, setShowEBModal] = useState(false);
  const [showEBExpiredLinkModal, setShowshowEBExpiredLinkModalModal] = useState(false);
  const [companyName, setCompanyName] = useState(EBCampaignCompanyName || "");
  const [canStartQuote, setCanStartQuote] = useState(false);
  const [currentInput, setCurrentInput] = useState<"DOB" | "Gender">("DOB");
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [genericError, setGenericError] = useState<string | undefined>(
    undefined
  );
  const [genericErrorType, setGenericErrorType] = useState<string | undefined>(
    undefined
  );
  const arcValidated = useRef<boolean>(false)

  const DobFormRef = useRef<null | HTMLDivElement>(null);
  const GenderFormRef = useRef<null | HTMLDivElement>(null);
  const SpacerRef = useRef<null | HTMLDivElement>(null);

  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams
  );
  const [aaTrackingStart, setAATrackingStart] = useState<string[]>([]);

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };

  // QB-AA-Tracking fix: maps each form name tracked on this page to its journey step.
  const BASIC_DETAILS_STEP_INFO: Record<string, { stepName: string; stepNumber: string }> = {
    mltc_dob_form: { stepName: "Date of Birth", stepNumber: "1" },
    mltc_gender_form: { stepName: "Gender", stepNumber: "2" },
  };

  const trackOnLoad = useCallback(
    (formName: string): void => {
      const GA = GAAviva.getInstance();
      let { form, acquisition, cta, page } = GA.digitalData;
      form.name = formName;
      form.error.fieldLabels = [];
      form.error.messages = [];
      form.error.numErrors = "0";
      cta = {
        text: "",
        type: "",
      };
      acquisition.insurance.campaignCode = campaignDetail
        ? campaignDetail.campaignCode
        : "MLO1";

      const stepInfo = BASIC_DETAILS_STEP_INFO[formName];
      page.journeyName = MLTC_R3_JOURNEY_NAME;
      page.stepName = stepInfo?.stepName || page.stepName;
      page.stepNumber = stepInfo?.stepNumber || page.stepNumber;

      // QB-AA-Tracking fix: BAU customers never see the step-0 QR/EB "start quote" modal
      // (see trackStartQuoteModal below), so this is the first step they hit - tag them
      // "standard" here, but only if step 0 hasn't already set a real value first.
      if (!form.experience) {
        form.experience = "standard";
      }

      // GA.trackPageStart(); //Remove because "Form Tracking Fix in xlxx page start on user input"
      GA.trackPageLoad({ form, acquisition, cta, page });
    },
    [campaignDetail]
  );

  // QB-AA-Tracking fix: step 0 - fires once, right when the QR "Continue to Quote" popup
  // or the EB company modal appears, so we can tag which of the 3 fast-tracked journeys
  // (or neither) the customer landed in before they ever reach step 1.
  const [hasTrackedStartQuoteModal, setHasTrackedStartQuoteModal] = useState(false);
  const trackStartQuoteModal = useCallback(
    (experience: "qr-fast-tracked" | "eb-journey" | "eb-qr-fast-tracked"): void => {
      if (hasTrackedStartQuoteModal) return;
      setHasTrackedStartQuoteModal(true);

      const GA = GAAviva.getInstance();
      let { form, page } = GA.digitalData;
      form.experience = experience;

      page.journeyName = MLTC_R3_JOURNEY_NAME;
      page.stepName = "Start Quote Modal";
      page.stepNumber = "0";

      GA.trackPageLoad({ form, page });
    },
    [hasTrackedStartQuoteModal]
  );

  const trackOnStart = (formName: string): void => {
    if (!aaTrackingStart.includes(formName)) {
      console.log("start form", formName);
      setAATrackingStart([...aaTrackingStart, formName]);
      const GA = GAAviva.getInstance();
      let { form } = GA.digitalData;
      form.name = formName;
      GA.trackPageStart();
    }
  };

  const getGenericError = (): string => {
    const urlParams: URLSearchParams = Helpers.getURLSearchParams();
    const dobError = urlParams.get("doberror");
    const nricerror = urlParams.get("nricerror");
    const genderError = urlParams.get("gendererror");
    const gendercodeerror = urlParams.get("gendercodeerror");    

    if (dobError === "true") {
      setGenericErrorType("dob");
      return "Oops, seems like your Date of Birth does not match your Singpass";
    }
    if (genderError === "true") {
      setGenericErrorType("gender");
      return "Oops, seems like your Gender does not match your Singpass.";
    }
    if (gendercodeerror === "true") {
      setGenericErrorType("gender");
      return "Opps, seems like something wrong with the Gender code. Kindly refresh and try again.";
    }
    if (nricerror === "true") {
      setGenericErrorType("nric");
      return "Oops, seems like your NRIC does not match your Singpass.";
    }
    setGenericErrorType("");
    return "";
  };

  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  const {
    handleChange,
    values,
    errors,
    formValid,
  }: {
    handleChange: (event: any) => void;
    values: any;
    errors: any;
    formValid: boolean;
  } = useForm(new BasicDetailsForm(basicDetails), () => {}, validate);  

  const age = basicDetails?.dob
    ? Helpers.getAge(
        new Date(
          `${basicDetails.dob.month}/${basicDetails.dob.day}/${basicDetails.dob.year}`,
        ),
      )
    : null;

  const isEBLTCAgeInEligibilty =
    campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED" && age !== null && (age < 31 || age > 40);

  const genderOnClick = useCallback(() => {
    setCurrentInput("Gender");
    trackOnLoad("mltc_gender_form");
    trackOnStart("mltc_gender_form");
    setTimeout(() => {
      switch (errors.dob?.errorCode) {
        case EErrorCode.ivalidDoBFormat:
          history.push("/mltc/contact-form");
          break;
        case EErrorCode.outOfAgeRange:
          setIsShowGotoContactModal(true);
          break;
        case EErrorCode.none:
          if (GenderFormRef && GenderFormRef.current) {
            var elementOffSetTop = GenderFormRef.current.offsetTop;
            calculateSpacer(GenderFormRef, SpacerRef, false);
            var top = window.pageYOffset || document.documentElement.scrollTop;
            scrollToRef(
              document.documentElement,
              "scrollTop",
              "",
              top,
              elementOffSetTop,
              300,
              true
            );
            GenderFormRef.current.style.opacity = "1";
          }
          break;
      }
    }, 100);

    if(isEBLTCAgeInEligibilty){
      dispatch(setCampaignDetail(null));
    }
    
  }, [errors.dob?.errorCode, history, trackOnLoad]);

  const onChange = (event: any) => {
    trackOnStart("mltc_dob_form");
    handleChange(event);
    const { name, value } = event.target;

    const nextCoverage = { ...coverage, promoCode: "", promoNric: "" };
    dispatch(updateCoverage(new CoverageForm(nextCoverage)));
    if (name === "dob") {
      dispatch(updateBasicDetails({ ...values, dob: value }));
      dispatch(updateCoverageTerm(""));
      dispatch(updatePlanDetails(null));
    }
    if (name === "gender") {
      dispatch(updateBasicDetails({ ...values, gender: value }));
      history.push("/mltc/choose-plan" + paramCC + analyticParam);
    }
  };
  

  const [isShowGotoContactModal, setIsShowGotoContactModal] = useState(false);
  const [isShowGotoChoosePlan, setIsShowGotoChoosePlan] = useState(false);

  useEffect(() => {
    if (!encryptedClntNum) return;
    if (hasShowQREligiblePopup) return;
    if (!validQRClient) return;

    const isEBLTCResolved = campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED";
    if (isEBLTCResolved) return; // EB company modal takes priority for QR+EB customers

    // If this QR client carries an EB campaign code, wait for the EB campaign lookup to
    // finish resolving (success or not) before falling back to the plain QR popup.
    if (clientQRData?.ebCampaignCode && !ebCampaignLookupComplete) return;

    setIsShowGotoChoosePlan(true);
    trackStartQuoteModal("qr-fast-tracked");
    dispatch(setHasShownQREligiblePopup(true));
  }, [encryptedClntNum, hasShowQREligiblePopup, validQRClient, clientQRData, campaignDetail, ebCampaignLookupComplete, dispatch, trackStartQuoteModal]);

  useEffect(() => {
    const hasShown = sessionStorage.getItem("ebExpiredModalShown");

    if (
      campaignDetail?.code === "EBLTC" &&
      campaignDetail?.status === "EXPIRED" &&
      !hasShown
    ) {
      setShowshowEBExpiredLinkModalModal(true);
      sessionStorage.setItem("ebExpiredModalShown", "true");
    }
  }, [campaignDetail]);

  useEffect(()=>{
    const termFromQR = clientQRData?.term;
    const monthlyBenefitFromQR = clientQRData?.maxMonthlyBenefit;
    const careShieldAvailablePlan = clientQRData?.plan === "EYA"  ? "MLTC" : clientQRData?.plan === "EYB" ? "MLTCP" : "";

    if (!encryptedCareShieldPlanName && careShieldAvailablePlan) {
      dispatch(updateCareShieldPlanName(careShieldAvailablePlan));
      dispatch(updatePlanSelection(careShieldAvailablePlan));
    }

    if (!QRTermValue && termFromQR) {
      dispatch(updateQRTerm(termFromQR));
    }

    if (!QRMonthlyBenefitValue && monthlyBenefitFromQR) {
      dispatch(updateQRMonthlyBenefit(monthlyBenefitFromQR));
    }
  },[clientQRData, dispatch, encryptedCareShieldPlanName, QRTermValue, QRMonthlyBenefitValue])

  useEffect(() => {
    if (!encryptedClntNum) return;
    if (!clientQRData) return;
    if (!validQRClient) return;
    if (genericErrorType === "dob" || genericErrorType === "gender") return;

    const dobFromQR = clientQRData?.dob
      ? (() => {
          const [year, month, day] = clientQRData.dob.split("-");
          return { day, month, year };
        })()
      : { day: undefined, month: undefined, year: undefined };

    dispatch(
      updateBasicDetails({
        dob: basicDetails?.dob ?? dobFromQR,
        gender: basicDetails?.gender ?? clientQRData?.gender,
      }),
    );

    if (!gioNricDetails && clientQRData?.nric) {
      dispatch(updateGIONRICDetails(clientQRData.nric));
    }
  }, [
    encryptedClntNum,
    basicDetails?.dob,
    basicDetails?.gender,
    gioNricDetails,
    clientQRData,
    validQRClient,
    genericErrorType,
    dispatch,
  ]);

  useEffect(() => {
    if (!basicDetails) return;

    if (basicDetails.dob) {
      handleChange({ target: { name: "dob", value: basicDetails.dob } });
    }
    if (basicDetails.gender) {
      handleChange({ target: { name: "gender", value: basicDetails.gender } });
    }
  }, [
    basicDetails?.dob?.day,
    basicDetails?.dob?.month,
    basicDetails?.dob?.year,
    basicDetails?.gender,
    handleChange,
  ]);
  
  const onBack = useCallback(() => {
    history.push("/mltc/lets-get-started" + paramCC + analyticParam);
  }, [history, paramCC, analyticParam]);

  const onDobFocus = () => {
    setCurrentInput("DOB");
  };
  
  const rawUrlParams = Helpers.getURLSearchParams();
  const hasQrCodeInUrl = !!rawUrlParams.get("qrCd");
  const hasCcCodeInUrl = !!rawUrlParams.get("cc");
  const isWaitingForQrClassification = hasQrCodeInUrl && !qrClientDetails;
  const isWaitingForEbClassification =
    validQRClient && !!clientQRData?.ebCampaignCode && !ebCampaignLookupComplete;
  const isWaitingForCcClassification = hasCcCodeInUrl && !ccCampaignLookupComplete;
  const isWaitingForClassification =
    isWaitingForQrClassification || isWaitingForEbClassification || isWaitingForCcClassification;

  const [hasClassificationWaitTimedOut, setHasClassificationWaitTimedOut] = useState(false);
  useEffect(() => {
    if (!isWaitingForClassification || hasClassificationWaitTimedOut) return;
    const timer = setTimeout(() => setHasClassificationWaitTimedOut(true), 6000);
    return () => clearTimeout(timer);
  }, [isWaitingForClassification, hasClassificationWaitTimedOut]);

  const isEBLTCResolvedForModal =
    campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED";
  const isQrModalPending =
    !!encryptedClntNum &&
    !hasShowQREligiblePopup &&
    validQRClient &&
    !isEBLTCResolvedForModal &&
    !(clientQRData?.ebCampaignCode && !ebCampaignLookupComplete);
  const isEbModalPending = isEBLTCResolvedForModal;

  useEffect(() => {
    if (DobFormRef.current) {
      DobFormRef.current.style.opacity = "1";
      calculateSpacer(DobFormRef, SpacerRef, true);
    }

    if (
      isShowGotoChoosePlan ||
      showEBModal ||
      isQrModalPending ||
      isEbModalPending ||
      (isWaitingForClassification && !hasClassificationWaitTimedOut)
    )
      return;

    trackOnLoad("mltc_dob_form");
  }, [
    trackOnLoad,
    isShowGotoChoosePlan,
    showEBModal,
    isQrModalPending,
    isEbModalPending,
    isWaitingForClassification,
    hasClassificationWaitTimedOut,
  ]);

  useEffect(() => {
    if (completedProcess) {
      dispatch(completeStep(false));
      Helpers.clearCached();
    }
    setGenericError(getGenericError());
    if (isEmpty(basicDetails)) {
      // onBack();
    }
  }, [basicDetails, onBack]);

  useEffect(() => {
    if (genericErrorType === "gender" && !resetQRValues) {
      genderOnClick();
    }
  }, [setGenericErrorType, genericErrorType, genderOnClick, resetQRValues]);

  useEffect(() => {
    const urlParams: URLSearchParams = Helpers.getURLSearchParams();
    const agentCode: string = urlParams.get("arc") || "";
    const promoCode: string = urlParams.get("pm")?.replace(/ /g, "+") || "";
    const clntNum: string = urlParams.get("qrCd") || "";
    if (!encryptedClntNum && clntNum) {
      dispatch(updateQRClntNum(clntNum));
    }
    if (!agentCode) return;
    const validateFarCode = async (option?: HTMLDivElement) => {
      console.log(`QnB ➤ onClickVerify(agentCode)`, { agentCode, promoCode});
      dispatch(setLoadingState(true));

      try {
        const response = await postGetPersonalDetails(
          new AgentPersonalDetailRequest({ agentCode, promoCode})
        );
        const data = get(response, "data.data", null);
        const validPromoCodeData: any = get(response, "data", null);
        const responseInfo = await postRetrieveInformation({
          sourceSystem: "MLTC",
          loggedInUserId: 0,
          clientNum: data?.clientNum,
          agentNo: agentCode,
        });
        const dataInfo = get(responseInfo, "data", null);
        const agentCoy = find(dataInfo, { agentCoy: "1" });
        console.log({ responseInfo, dataInfo, agentCoy });
        dispatch(updateValidPromoCodeValidity(validPromoCodeData?.validPromoCode));
        dispatch(updateAgentDetailResponseRaw(data));
        dispatch(updatePromoCode(promoCode));
        dispatch(updateAgentInformation(responseInfo));
        dispatch(updateShowArcPage(true));

        if (
          data?.fullName &&
          !isEmpty(data?.fullName) &&
          data?.agentTerminatedFlag !== "Y"
        ) {
          dispatch(updateUrlParam({ ...analyticUrlParams, arc: agentCode, pm: promoCode, qrCd: clntNum}));
          dispatch(setInvalidArcCodeFromUrl(false));
        } else {
          dispatch(updateUrlParam({ ...analyticUrlParams, arc: "", pm: "", qrCd: ""}));
        }
        dispatch(setLoadingState(false));
      } catch (error) {
        console.error("error", error);
        dispatch(updateAgentDetailResponseRaw(null));
        dispatch(updateAgentInformation(null));
        setTimeout(() => {
          dispatch(setLoadingState(false));
        }, 1000);
      }
    };
    if (agentCode && !arcValidated.current) {
      arcValidated.current = true;
      validateFarCode();
    }    
  }, []);

  const onGotoContactModalClose = () => {
    setIsShowGotoContactModal(false);
  };

  const onGotoContactModalConfirm = () => {
    history.push("/mltc/contact-form?variant=true");
  };

   const onGotoChoosePlanContinue = () => {
    history.push("/mltc/customise-plan");
    setIsShowGotoChoosePlan(false);
  }; 

  const ANIMATE_LOGO_STYLES: React.CSSProperties = {
    zIndex: -1,
    opacity: 0.1,
  };

  const SpinLogo = styled.div`
    position: absolute;
    width: 215px;
    height: 211px;
    right: 80px;
    top: 60px;
    z-index: -1;
    span {
      position: relative;
      display: block;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(
          to top,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0.7),
          transparent
        );
      }
    }

    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      width: 415px;
      height: 407px;
    }
  `;

  const errorTypeFromUrl = () => {
    const params = Helpers.getURLSearchParams();
    if (params.get("doberror") === "true") return "dob";
    if (params.get("gendererror") === "true") return "gender";
    if (params.get("gendercodeerror") === "true") return "gender";
    if (params.get("nricerror") === "true") return "nric";
    return "";
  };

  useEffect(() => {
    const errorMessage = getGenericError();
    setGenericError(errorMessage);

    if (!errorMessage) return;

    const errorType = errorTypeFromUrl();
    const qrInvalidatingErrors = ["dob", "gender", "nric"];

    dispatch(resetToIntialStateStep4(""));

    if (validQRClient && qrInvalidatingErrors.includes(errorType)) {
      dispatch(
        updateBasicDetails({
          dob: { day: undefined, month: undefined, year: undefined },
          gender: "",
        }),
      );

      dispatch(updateGIONRICDetails(""));
      dispatch(updatePlanSelection(null));
      dispatch(updateQRMonthlyBenefit(""));
      dispatch(updateQRTerm(""));
      dispatch(resetQRData(true));
      dispatch(updateUrlParam({ ...analyticUrlParams, qrCd: "" }));
      handleChange({ target: { name: "dob", value: "" } });
      handleChange({ target: { name: "gender", value: "" } });
      dispatch(
        updateQRClientDetails({
          status: "FAILURE",
          clientMasterData: null,
        }),
      );

      if (campaignDetail?.code === "EBLTC") {
        // QR+EB customer failed MyInfo validation - fall back fully to BAU, not just plain QR
        dispatch(setCampaignDetail(null));
        dispatch(updateEBCampaignCompanyName(""));
      }
    }
  }, [location.search, validQRClient, campaignDetail, dispatch]);

  useEffect(() => {
    const isEBLTC = campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED";
    setShowEBModal(isEBLTC);

    if (!isEBLTC) return;

    trackStartQuoteModal(validQRClient ? "eb-qr-fast-tracked" : "eb-journey");

    setCompanyName(EBCompanyName ?? "");
    setCanStartQuote(Boolean(EBCompanyName));
  }, [campaignDetail, EBCompanyName, validQRClient, trackStartQuoteModal]);

  const onCompanyNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCompanyName(value);
    setCanStartQuote(value.trim().length > 0);
  };

  const onStartQuote = () => {
    setShowEBModal(false);
    dispatch(updateEBCampaignCompanyName(companyName));

    if (validQRClient) {
      // QR+EB customers skip manual Basic Info entry and land directly on the Quote page
      history.push("/mltc/customise-plan" + paramCC + analyticParam);
    }
  };

  const onExpiredLink = () => {
    setShowshowEBExpiredLinkModalModal(false);
    history.push('/mltc/lets-get-started');
    dispatch(setCampaignDetail(null));
  };

  useEffect(() => {
    if (EBCampaignCompanyName) {
      setCompanyName(EBCampaignCompanyName);
      setCanStartQuote(true);
    }
  }, [EBCampaignCompanyName]);

  return (
    <BasicInfoContainer>
      <FormContainer ref={DobFormRef} margin={"150px auto 0 auto"}>
        <>
          <SpinLogo>
            <span>
              <Lottie
                loop={true}
                animationData={animate_logo_json}
                play={true}
                style={ANIMATE_LOGO_STYLES}
              ></Lottie>
            </span>
          </SpinLogo>
          <HeaderTitle>
            Singlife <span>CareShield Standard/Plus</span>
          </HeaderTitle>
          <Text fontSize={25} fontWeight={600}>
            Get a quote within minutes
          </Text>
          <List>
            {productDescription?.map((list: string, i: number) => (
              <ListItem key={i}>
                <span>
                  <Icon name="tick-purple" className="tickpurple" />
                </span>
                <Text margin="0 0 0 15px" fontSize={14}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(list),
                    }}
                  ></span>
                </Text>
              </ListItem>
            ))}
          </List>
          <Text fontSize={12} color="#8A8988">
            {disclaimer && disclaimer}
          </Text>
        </>

        <DOBInputGroup>
          <TitleContainer>
            <TitleAndDescription
              title="Let's start with your date of birth"
              description="Enter in DD-MM-YYYY format."
            />
            {errors?.dob?.message && (
              <ErrorMessage>
                <Icon name="alert-circle-red" width={18} />
                <Typography color="#434343" variant="base" fontWeight={400}>
                  {errors?.dob?.message}
                </Typography>
              </ErrorMessage>
            )}
            {genericError && genericErrorType === "dob" && !resetQRValues && (
              <ErrorMessage>
                <Icon name="alert-circle-red" width={18} />
                <Typography color="#434343" variant="base" fontWeight={400}>
                  {genericError}
                </Typography>
              </ErrorMessage>
            )}
          </TitleContainer>
          <DayOfBirth
            name="dob"
            value={basicDetails?.dob ?? values["dob"]}
            onChange={onChange}
            onFocus={onDobFocus}
          />
          {resetQRValues && (
            <div className={QRErrorBanner}>
              <img src={warningIcon} alt="warning icon" />
              <div className={QRBannerContent}>
                Your date of birth, gender or NRIC does not match with Myinfo.
                Please enter the correct details.
              </div>
            </div>
          )}
          {isEBLTCAgeInEligibilty && (
            <div className={QRErrorBanner}>
              <img src={warningIcon} alt="warning icon" />
              <div className={QRBannerContent}>
                This promotion is only available to customers aged 31 to 40 years old. You can still get a regular quote without the promotion.
              </div>
            </div>
          )}
          <div className={buttonCss}>
            <Button
              label={`${
                errors.dob?.errorCode === EErrorCode.ivalidDoBFormat
                  ? "Need Help?"
                  : "Next"
              }`}
              variant="default"
              width="180px"
              height="52px"
              padding="15px 0"
              disabled={!errors?.dob?.isValid}
              onClick={genderOnClick}
            />
          </div>
        </DOBInputGroup>
      </FormContainer>
      {currentInput === "Gender" && (
        <FormContainer ref={GenderFormRef} margin={"150px auto 0 auto"}>
          <GenderInputGroup>
            <TitleContainer>
              <TitleAndDescription
                title="What is your gender?"
                description="As per your NRIC/FIN"
              />
              {genericError && genericErrorType === "gender" && !resetQRValues && (
                  <ErrorMessage>
                    <Icon name="alert-circle-red" width={18} />
                    <Typography color="#434343" variant="base" fontWeight={400}>
                      {genericError}
                    </Typography>
                  </ErrorMessage>
                )}
            </TitleContainer>
            <RadioButtonGroup
              value={values["gender"]}
              name="gender"
              activeType="fill"
              widthIcon={true}
              iconALign="top"
              textAlign="center"
              padding={
                screenSize >= 768 ? "42px 132px 42px 132px" : "11px 0 11px 0"
              }
              onChange={onChange}
              width={screenSize >= 768 ? 314 : undefined}
              height={screenSize >= 768 ? 158 : undefined}
            >
              <RadioButton
                text="Male"
                value="M"
                iconActive="male"
                iconInactive="male"
                iconHover="male"
              />
              <RadioButton
                text="Female"
                value="F"
                iconActive="female"
                iconInactive="female"
                iconHover="female"
              />
            </RadioButtonGroup>
          </GenderInputGroup>
        </FormContainer>
      )}

      <div ref={SpacerRef}></div>

      <Stepper steps={stepsList}></Stepper>

      <Modal show={isShowGotoContactModal}>
        <TitleAndDescription
          title="Oops, we have encountered an issue"
          description="The age range for the purchase for this product is 31 - 65 (age next birthday). If you do not fall within this range clicking on ‘Yes’ will direct you to the contact form."
          margin={screenSize < 768 ? "0 0 48px 0" : "0 0 80px 0"}
          padding={screenSize < 768 ? "0" : "0 10px"}
        />
        <ActionButton
          actionType="confirm"
          closeLabel={screenSize < 768 ? "No" : "Back"}
          confirmlabel={"Yes"}
          width="180px"
          onClose={onGotoContactModalClose}
          onConfirm={onGotoContactModalConfirm}
        />
      </Modal>

      <QRSuccessModal
        show={isShowGotoChoosePlan}
        onClose={onGotoContactModalClose}
      >
        <img src={successTickIcon} alt="icon-img" />
        <Title>Let's get started!</Title>
        <SubTitile>
          You can review your current plan and monthly benefits next.
        </SubTitile>
        <div style={{ marginTop: "1.5rem" }}>
          <Button
            label={"Continue"}
            width="144px"
            height="auto"
            margin={"auto"}
            fontSize="14px"
            onClick={onGotoChoosePlanContinue}
          />
        </div>
      </QRSuccessModal>

      <EBCampaignModal show={showEBModal} onClose={() => setShowEBModal(false)} className={customModalCss}>
        <img src={EBCampaignBanner} style={{width: "-webkit-fill-available"}}/>
        <div className={EBModalContainerCss}>
          <div className={EBModalHeaderCss}>
            You've unlocked up to S$599 off!
          </div>
          <div className={EBModalSubHeaderCss}>
            Enjoy this exclusive employee benefit on your first-year CareShield
            premium.
          </div>

          <div className={companyNameLabelCss}>
            Company Name{" "}
            {!EBCompanyName && <span style={{ color: "red" }}>*</span>}
          </div>

          {EBCompanyName ? (
            <div className={companyNameValueCss}>{companyName}</div>
          ) : (
            <>
              <input
              type="text"
              value={companyName}
              onChange={onCompanyNameChange}
              placeholder="Search company"
              className={companyNameInputCss}
            />
            <div className={companyNameInputNoteCss}>Enter your company name to apply the benefit to your quote.</div>
            </>
            
          )}
          <div className={startQuoteButtonContainerCss}>
            <Button
            label="Start quote"
            width="160px"
            disabled={!canStartQuote}
            onClick={onStartQuote}
          />
          </div>
          
        </div>
      </EBCampaignModal>
      <EBExpiredLinkModal show={showEBExpiredLinkModal} onClose={() => setShowshowEBExpiredLinkModalModal(false)} className={customExpiredModalCss}>
        <img className={imgCss} src={InfoAnimationIcon} alt="icon-img" />
        <div className={expiredModalTitle}>Promotion has ended</div>
        <div className={expiredModalDesc}>You can still purchase Singlife CareShield and secure the long-term care coverage you need.</div>
          <div className={buttonContainerCss}>
            <Button
            label="Start quote"
            width="160px"
            onClick={onExpiredLink}
          />
          </div>
      </EBExpiredLinkModal>

      <BottomSheet />
    </BasicInfoContainer>
  );
};

export default BasicDetailsMLTCR3;

const Title = styled.div`
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin-top: 1.5rem;
  color: #434343;
`;

const SubTitile = styled.div`
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  margin-top: 1rem;
  color: #434343;
`;

const buttonCss = css`
  margin-top: 64px;
  width: 180px;

  @media screen and (min-width: 768px) {
    margin-top: 80px;
    width: auto;
  }
`;

const QRErrorBanner = css`
  background-color: #FFFCE4;  
  border-radius : 1rem;
  padding: 1rem;
  display: flex;
  gap: 0.5rem;
  margin: 0.5rem 0;
  width: auto;

  @media screen and (min-width: 768px) {
    width: 100%;
  }
`;

const QRBannerContent = css`
  font-size: 14px;
  font-weight: 400;
  color: #655B00;
`;

const HeaderTitle = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  letter-spacing: -0.02em;
  color: #434343;
  margin-bottom: 24px;

  span {
    color: #883e89;
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 48px;
  }
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  margin: 12px 0 24px;
`;

const ListItem = styled.li`
  display: flex;
  column-gap: 8px;
  align-items: center;
  font-size: 14px;
`;

const expiredModalTitle = css`
  color: #434343;
  font-weight: 600;
  font-size: 18px;
  margin: 1rem 0;
`;

const imgCss = css`
  margin-top: 1.5rem;
`;

const expiredModalDesc = css`
  color: #434343;
  font-weight: 400;
  font-size: 14px;
  margin: 0 1.5rem;
  padding: 0 1.5rem;
`;

const EBModalContainerCss = css`
  padding: 1.5rem;
`;

const EBModalHeaderCss = css`
  font-size: 18px;
  font-weight: 600;
  color: #434343;
`;
const EBModalSubHeaderCss = css`
  font-size: 14px;
  font-weight: 400;
  color: #434343;
  margin-top: 1rem;
`;

const companyNameLabelCss = css`
  font-size: 14px;
  font-weight: 400;
  color: #434343;
  margin-top: 2rem;
`;

const companyNameValueCss = css`
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin-top: 1.5rem;
`;

const companyNameInputCss = css`
  width: 100%;
  margin-top: 1rem;
  font-size: 14px;
  border: none;
  border-bottom: 1px solid #D8D8D8;
  padding: 0 0 8px 0;
  color: #000000;

  &:focus {
    outline: none;
    border-color: #000000;
  }
`;

const companyNameInputNoteCss = css`
  color: #8A8988;
  font-size: 12px;
  font-weight: 600;
  margin-top: 0.5rem;
`;

const startQuoteButtonContainerCss = css`
  justify-content: center;
  display: flex;
  margin-top: 2rem;
`;

const buttonContainerCss = css`
  justify-content: center;
  display: flex;
  margin: 1.5rem 0;
`;

const customModalCss = css`
  border-radius: 1rem;
  overflow-y: hidden;
`;

const customExpiredModalCss = css`
  text-align: center;
  padding: 1.5rem;
  gap: 1.5rem;
`;
